import React, { useContext } from 'react';
import axios from 'axios';
import { Link } from '@reach/router';
import { MedataContext } from '../../../../../../ContexMedata';

function FileDownload({ title, hasPreview, format, downloadURL, id, description }) {

  const { datasetDonwloads, setDatasetDonwloads } = useContext(MedataContext);
  var label = title || format;
  const buttonStyle = (!hasPreview) ? { justifyContent: 'flex-start' } : {};

  const currentUrl = window.location.href;

  const finalUrl = (currentUrl.startsWith('https://') ? ((downloadURL.startsWith('http://') >= 0) ? downloadURL.replace('http://', 'https://') : downloadURL) : downloadURL);

  const downloadsFunc = async () => {
    var counter = 0;
    //const { data } = await axios.get(`${process.env.REACT_APP_JSON_API_GET_DATA}${id}/${process.env.REACT_APP_JSON_API_GET_DATA_FIELDS}`);

    //console.log('Data => ', data)

    //console.log('Descargas => ', data.data.attributes.field_descargas)
    /*     if (data.data.attributes.field_descargas == null) {
          counter = 1
        } else {
          counter = data.data.attributes.field_descargas + 1
        } */
    if (datasetDonwloads == 0) {
      counter = 1
    } else {
      setDatasetDonwloads(datasetDonwloads + 1)
      counter = datasetDonwloads
    }
    console.log('counter => ', counter)

    const headers = {
      'Content-Type': 'application/vnd.api+json'
    };
    const auth = {
      username: process.env.REACT_APP_JSON_API_USER,
      password: process.env.REACT_APP_JSON_API_PASS
    }

    const dataPatch = {
      "data": {
        "type": "node--data",
        "id": id,
        "attributes": {
          "field_descargas": counter
        }
      }
    }

    console.log('Url Update => ', `${process.env.REACT_APP_JSON_API_GET_DATA}${id}`)
    await axios.patch(`${process.env.REACT_APP_JSON_API_GET_DATA}${id}`, dataPatch, {
      headers: headers,
      auth: auth
    }).catch(function (error) {
      if (error.response) {
        // La respuesta fue hecha y el servidor respondió con un código de estado
        // que esta fuera del rango de 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // La petición fue hecha pero no se recibió respuesta
        // `error.request` es una instancia de XMLHttpRequest en el navegador y una instancia de
        // http.ClientRequest en node.js
        console.log(error.request);
      } else {
        // Algo paso al preparar la petición que lanzo un Error
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
    console.log('Actualizacion descargas realizada')
  }


  return (
    <div className='data-actions pl-2'>
      <a href={finalUrl} title={label} className='button button-secondary' onClick={() => downloadsFunc()}>
        <i className='fa-solid fa-download'>
        </i>
        {` ${label}`}
      </a>
    </div>
  )

}

export default FileDownload